module.exports = __webpack_public_path__ + "images/male-back&arms.png";